module.exports = __webpack_public_path__ + "static/media/tick_icon.ac519b50.svg";